/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { observable, action } from "mobx";

class ThumbnailStore {
  @observable shouldShowThumbnailIcon;
  @observable shouldFocusThumbnail;
  @observable thumbnailColumnCount;

  constructor() {
    this.init();
  }

  initStore(docApi, stores) {
    if (docApi) {
      this.docApi = docApi;
    }
    if (stores) {
      this.stores = stores;
    }
  }

  @action
  init() {
    this.shouldShowThumbnailIcon = true;
    this.shouldFocusThumbnail = true;
    this.thumbnailColumnCount = 1;
  }

  @action
  setShouldShowThumbnailIcon(value) {
    this.shouldShowThumbnailIcon = value;
  }

  @action
  setShouldApplyFocus(value) {
    this.shouldFocusThumbnail = value;
  }

  @action
  setThumbnailColumnCount(value) {
    this.thumbnailColumnCount = value;
  }
}

export { ThumbnailStore };
